export const API_HOST: string = process.env.REACT_APP_API_HOST as string;
export const IMAGE_HOST: string = process.env.REACT_APP_IMAGE_HOST as string;
export const RECAPTCHA_SITE_KEY: string = process.env
  .REACT_APP_RECAPTCHA_SITE_KEY as string;
